<template>
  <div>

   
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import CommercialList from '../../api/query/CommercialList.gql'
  import WarrantyOptionList from '../../api/query/WarrantyOptionList.gql'
  import { formatDateTime } from '../../helpers/filters/filter'
  import { addressToString } from '../../helpers/utils'
  import Alert from '../../components/Alert.vue'
  import Status from "@/components/details/Status.vue"

  export default {
    props: {
      command: {
        type: Object,
        required: true
      }
    },
    components: {
      'component-alert': Alert
    },

    data: () => ({
      accountManager: [],
      warrantyOptions: [],
      fromBO: true,
      options: {
        warranty: null,
        payment: null,
        disposalType: null
      },
      initialOptionsPrice: null,
      warrantyDisabled: true,
      paymentDisabled: true,
      disposalTypeDisabled: true,
      codePromo: {
        showInput: false,
        input: '',
        details: null
      },
      checkPromoCode: null,
      deliveryAddress: '',
    }),

    computed: {
      commandId () {
        return this.$route.params.id
      },

      commercial () {
        return this.command.commercial
      },

      vehicle () {
        return this.command.vehicule[0]
      },

      buyer () {
        return this.command.buyer[0]
      },

      getFormalityPrice () {
        return 59
      },

      getWarrantyPrice () {
        const result = this.warrantyOptions.find(o => o.id === this.options.warranty)

        return (undefined === result) ? 0 : result.cost;
      },

      getDisposalLabel () {
        switch (this.options.disposalType) {
          case 1:
            return 'Livraison'
          case 2:
            return 'Rendez-vous de cession'
          default:
            return ''
        }
      },

      getPaymentLabel () {
        switch (this.options.payment) {
          case 1:
            return 'Virement bancaire'
          case 2:
            return 'Chèque de banque'
          default:
            return ''
        }
      },

      getDisposalPrice () {
        switch (this.options.disposalType) {
          case 1:
            return 250 //supposé, il faut en réalité récupérer le prix renvoyé par l'API expédicar
          case 2:
            return 0
          default:
            return 0
        }
      },

      getBuyerToCarizyTotalPrice () {
        let total = this.getWarrantyPrice + this.getDisposalPrice + this.getFormalityPrice
        return total
      },

      getBuyerToSellerTotalPrice () {
        return this.command.buyerPrice
      },

      getBuyerTotalPrice () {
        return this.getBuyerToCarizyTotalPrice + this.getBuyerToSellerTotalPrice
      },

      getSellerToCarizyTotalPrice () {
        return this.command.saleCommission + this.getSellerToCarizyDiscount
      },

      getSellerToCarizyDiscount () {
        if (!this.codePromo.details) {
          return 0
        }
        return -1*(this.command.saleCommission*this.codePromo.details.value)
      },

      saleRdvLabel () {
        if (!this.command.saleRdv) {
          return null
        }
        let label = this.command.delivery ? 'Livraison le ' : 'Rendez-vous de cession le '
        label += formatDateTime(this.command.saleRdv[0].date)
        if (!this.command.delivery) {
          label += ` avec ${this.command.saleRdvExpert.name} (${this.command.saleRdvExpert.phonenumber})`
        }
        return label
      },

      willBeExpired () {
        if (!this.command.saleRdv) {
          return false
        }
        return moment().diff(moment(this.command.saleRdv[0].date), 'days') < 0
      },

      promoQuery () {
        return gql`
        {
          checkPromoCode (codePromo: "${this.codePromo.input}") {
            isValid
            name
            value
          }
        }`
      },

      cancelDisposalMutation () {
        return gql`
          mutation {
            deleteSaleRdv(saleRdvId: ${this.command.saleRdv[0].id})
            {
              result
            }
          }`
      },

      deleteCommandQuery () {
        return gql`
          mutation {
            cancelOrder (orderId : ${this.commandId}){
              status
              result
            }
          }`
      },

      modifyOrderMutation () {
        return gql`
        mutation {
          modifyOrder(
            orderId:"${this.commandId}",
            commercial: ${this.commercial.id},
            warranty: ${this.options.warranty},
            paymentMode: ${this.options.payment},
            cessionMode: ${this.options.disposalType},
            status: ${this.command.status.id},
            promoCode: "${this.codePromo.details ? this.codePromo.details.name : ''}"
          ) {
            id,
            status,
            result
            }
         }`
      },

      optionsPrice () {
        return this.getWarrantyPrice + this.getDisposalPrice + this.getSellerToCarizyDiscount
      },

      optionsPriceDifference () {
        return this.optionsPrice - this.initialOptionsPrice
      },

      saveButtonLabel () {
        if (!this.optionsPriceDifference) {
          return 'Enregistrer les modifications'
        }
        if (this.optionsPriceDifference > 0) {
          return `Payer les ${this.optionsPriceDifference} € et enregistrer les modifications`
        }
        return `Demander le remboursement de l'acheteur de ${this.optionsPriceDifference} € et enregistrer les modifications`
      }
    },

    watch: {
      'options.payment': function () {
        if (this.options.payment === 2) {
          if (this.options.disposalType === 1) {
            this.options.disposalType = 2
          }
        }
      }
    },

    created () {
      this.options.warranty = this.command.options[0].id
      this.options.disposalType = this.command.delivery ? 1 : 2
      this.options.payment = this.command.paymentMode

      if (this.command.promoCode) {
        this.codePromo.details = this.command.promoCode
      }
      store.order.id = this.$route.params.id
    },

    mounted () {
        $(document).trigger('vue-loaded')
    },

    methods: {
      confirm (type) {
        let content = '';
        if (type === 'warranty') {
          content = 'Souhaitez-vous changer de garantie ?'
        } else if (type === 'payment') {
          content = 'Souhaitez-vous annuler ce moyen de paiement ?'
        } else if (type === 'disposal') {
          content = 'Souhaitez-vous annuler ce moyen de cession ?'
        } else if (type === 'delete') {
          content = 'Souhaitez-vous annuler cette commande ?'
        }
        this.showModal({
          childVue: 'confirm',
          dataModel: {
            title: 'Êtes-vous sûr ?',
            content,
            type
          }
        })
      },

      onWarrantyConfirm () {
        this.warrantyDisabled = false
      },

      onPaymentConfirm () {
        this.paymentDisabled = false
      },

      onDisposalConfirm () {
        this.disposalTypeDisabled = false

        if (this.command.saleRdv) {
          this.$apollo.mutate({
            mutation: this.cancelDisposalMutation
          }).then(() => {
            this.showBanner('success', `Succès: Le rendez-vous de cession a bien été supprimé`)
            this.command.saleRdv = null
            this.command.status.id = Status.constants.TO_PLANIFY
          })
        }
      },

      applyPromo () {
        this.$apollo.query({
          query: this.promoQuery
        }).then((response) => {
          if (response.data.checkPromoCode.isValid) {
            this.codePromo.details = response.data.checkPromoCode
            this.showBanner('success', `Succès: code promo ${this.codePromo.details.name} appliqué`)
          } else {
            this.codePromo.details = null
            this.showBanner('danger', `Le code promo indiqué n'est pas valide`)
          }
        })
      },

      onDeleteOrderConfirm () {
        this.$apollo.mutate({
          mutation: this.deleteCommandQuery
        }).then(() => {
          this.showBanner('success', `Succès: la commande #${this.commandId} a bien été annulée`)
          this.$router.push('/')
        }, () => {
          this.showBanner('danger', `La commande #${this.commandId} n'a pas pu être annulée`)
        })
      },

      modifyOrder () {
        this.$apollo.mutate({
          mutation: this.modifyOrderMutation
        }).then(() => {
          this.showBanner('success', `Succès: la commande #${this.commandId} a bien été modifiée`)
        }, () => {
          this.showBanner('danger', `La commande #${this.commandId} n'a pas pu être modifiée`)
        })
      },

      toggleCodePromoInput () {
        this.codePromo.showInput = !this.codePromo.showInput
      }
    },

    apollo: {
      accountManager: {
        query: CommercialList
      },

      warrantyOptions: {
        query: WarrantyOptionList,
        variables () {
          return {
            orderId: this.commandId,
            fromBO: this.fromBO
          }
        },
      }
    }
  }
</script>
